import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {CompanyWeaveStructure} from '@domain/textile-data/company-weave-structure/company-weave-structure';
import {NotImplementedError} from '@vdw/angular-component-library';
import {Observable} from 'rxjs';
import {map as rxjsMap} from 'rxjs/operators';
import {CompanyWeaveStructures} from './company-weave-structures';

@Injectable()
export class HttpCompanyWeaveStructuresService implements CompanyWeaveStructures {
  private httpClient: HttpClient;
  private backendConfiguration: BackendConfiguration;

  public constructor(httpClient: HttpClient, backendConfiguration: BackendConfiguration) {
    this.httpClient = httpClient;
    this.backendConfiguration = backendConfiguration;
  }

  public getAll(): Observable<CompanyWeaveStructure[]> {
    throw new NotImplementedError();
  }

  public getById(id: string): Observable<CompanyWeaveStructure> {
    throw new NotImplementedError();
  }

  public save(item: CompanyWeaveStructure): Observable<number> {
    throw new NotImplementedError();
  }

  public update(item: CompanyWeaveStructure): Observable<void> {
    return this.httpClient.put<void>(`${this.backendConfiguration.getEndpoint()}companyweavestructures`, item.toJSON(false));
  }

  public delete(id: number): Observable<void> {
    throw new NotImplementedError();
  }

  public saveCompanyWeaveStructure(item: CompanyWeaveStructure): Observable<void> {
    return this.httpClient.post<void>(`${this.backendConfiguration.getEndpoint()}companyweavestructures`, item.toJSON());
  }

  public getByCompanyId(companyId: string): Observable<number[]> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}companyweavestructures/${companyId}`).pipe(
      rxjsMap((weaveStructureIds: number[]) => {
        return weaveStructureIds;
      })
    );
  }
}
